export function pagination() {
    const pagination = document.querySelector('#pagination');
    if (!pagination)
        return;
    const text = pagination.dataset.text;
    const listElements = pagination.querySelectorAll('li:not(:first-child):not(:last-child):not(.spv-pagination__item--disabled)');
    listElements.forEach(element => {
        const link = element.querySelector('.js-pagination-link');
        const string = `${text} ${link.innerText}`;
        if (element.classList.contains('js-pagination-active')) {
            link.setAttribute('aria-current', 'page');
        }
        link.setAttribute('aria-label', string);
    });
}
pagination();
//# sourceMappingURL=pagination.js.map